import Button from "../../components/Button";
import styles from "./SubmitBar.module.css";

interface Props {
  isSubmitting: boolean;
  onCancel: () => void;
}

const SubmitBar = ({ isSubmitting, onCancel }: Props) => {
  return (
    <>
      <div className={styles.spacing}></div>
      <div className={styles.overlay}></div>
      <div className={styles.bottomActionButtons}>
        <Button
          type="accent_secondary"
          fullWidth={true}
          buttonProps={{
            onClick: onCancel,
          }}
        >
          Cancel
        </Button>
        <Button
          type="accent"
          fullWidth={true}
          isLoading={isSubmitting}
          buttonProps={{
            type: "submit",
            disabled: isSubmitting,
          }}
        >
          Save
        </Button>
      </div>
    </>
  );
};
export default SubmitBar;
